import { Preloader } from "../../common";
import { isRequestSuccess } from "../../../utils";
import { useInvenotory } from "../../../effects/data-accessors/useInventory";
import { SecurityHistory } from "../SecurityHistory";
import { PxTalkHistoricalColorDispersion } from "../PxTalkHistoricalColorDispersion";
import { useAppSelector } from "../../../effects/useAppSelector";
import { useSecurityBwicHistory } from "../../../effects/data-accessors/useSecurityBwicHistory";

interface BWICLogProps {
    evalPriceTalkVisible?: boolean;
}

export const BWICLog = ({ evalPriceTalkVisible = false }: BWICLogProps) => {
    const security = useAppSelector(s => s.bwicLog.security);
    const inventoryState = useInvenotory(security == null, [], security?.ticker ? security.ticker : '');
    const bwicsHistory = useSecurityBwicHistory(security?.securityId ?? 0);

    if (!security) return null;

    const isInitialized = 
        isRequestSuccess(bwicsHistory.requestState) && 
        isRequestSuccess(inventoryState.requestState);

    return (
        <div className="security-information">
            <Preloader inProgress={!isInitialized}>
                <>
                    <PxTalkHistoricalColorDispersion
                        securityStatistics={bwicsHistory.bwics}
                        securityId={security.securityId}
                        evalPriceTalkVisible={evalPriceTalkVisible}
                    />
                    {
                        (!!bwicsHistory.bwics.count || !!inventoryState.inventory.length) &&
                        <SecurityHistory
                            securityIdentifier={security.ticker}
                            bwicsHistory={bwicsHistory.bwics}
                            inventory={inventoryState.inventory}
                        />
                    }
                </>
            </Preloader>
        </div>
    )
}
